import { render, staticRenderFns } from "./wxAppDialog.vue?vue&type=template&id=79f009ea&"
import script from "./wxAppDialog.vue?vue&type=script&lang=js&"
export * from "./wxAppDialog.vue?vue&type=script&lang=js&"
import style0 from "./wxAppDialog.vue?vue&type=style&index=0&id=79f009ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports